<template>
  <div class="yxtbiz-kng-scorm-complete-standard color-gray-10 standard-size-14">
    <div>{{ $t('pc_biz_kng_lbl_class_completion_standard'/**完课标准 */) }}</div>
    <div class="color-gray-7 standard-size-12">{{ $t('pc_kng_uplaoder_intro_standard_4'/** 课件发布之后，完课标准无法再次编辑 */) }} </div>
    <yxt-radio-group
      class="mt8"
      v-model="type"
      type="tab-radio"
    >
      <yxt-radio-button
        :label="item.value"
        :key="item.value"
        v-for="item in completeTypes"
      >
        <div class="yxtbiz-flex-center">
          {{ item.label }}
          <yxt-tooltip
            v-if="item.tooltip"
            effect="dark"
            :content="item.tooltip"
            placement="top"
          >
            <yxt-svg
              icon-class="question-cirlce-o"
              class="ml4"
              width="16px"
              height="16px"
            ></yxt-svg>
          </yxt-tooltip>
        </div>
      </yxt-radio-button>
    </yxt-radio-group>
    <div class="mt8 p16 bg-gray-1">
    <div v-if="type === 'time' || type === 'timeAndContent'" class="yxtbiz-flex-center">
      <yxtbiz-language-slot lang-key="pc_biz_lbl_studytimepercent">
        <yxt-select
          v-model="percent"
          class="yxtbiz-w100"
          slot="0"
          @change="change"
        >
          <yxt-option label="100%" :value="100"></yxt-option>
          <yxt-option label="95%" :value="95"></yxt-option>
          <yxt-option label="90%" :value="90"></yxt-option>
          <yxt-option label="85%" :value="85"></yxt-option>
          <yxt-option label="80%" :value="80"></yxt-option>
          <div slot="fixed-footer">
            <yxt-input-number
              v-model="customPercent"
              class="yxtbiz-w110"
              size="small"
              :precision="0"
              :max="100"
              :min="1"
              :formatter="value => (value ? `${value}%` : '')"
              :placeholder="$t('pc_kng_standard_lbl_custom'/** 自定义 */)"
            ></yxt-input-number>
          </div>
        </yxt-select>
      </yxtbiz-language-slot>
    </div>
    <div v-if="type === 'content' || type === 'timeAndContent'" :class="{'mt16': type === 'timeAndContent'}">
      {{ $t('pc_kng_uplaoder_intro_onlycontentComplete_content' /** 完成课件内容获得学分 */) }}
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YxtbizKngScormCompleteStandard',
  name_zh: 'scorm完课标准',
  props: {
    contentCompleteStandard: {
      type: Number,
      require: true,
      default: 0,
      desc: '内容完课标准,0：默认 1：按内容完成',
      setter: 'NumberSetter'
    },
    timeCompleteStandard: {
      type: Number,
      require: true,
      default: 100,
      desc: '时长完课标准',
      setter: 'NumberSetter'
    }
  },
  data() {
    return {
      completeTypes: [ {
        label: this.$t('pc_kng_courseware_standard_lbl_duration'/** 时长 */),
        value: 'time',
        tooltip: this.$t('pc_kng_uplaoder_lbl_standard_tip'/** 完成标准学时，即可获得学分 */)
      }, {
        label: this.$t('pc_kng_courseware_standard_lbl_content'/** 内容 */),
        value: 'content',
        tooltip: this.$t('pc_kng_uplaoder_scorm_content_tip'/** 完成课件内容即可获得学分（需要课件支持内容记录，否则学员无法完成该课件） */)
      }, {
        label: this.$t('pc_kng_uplaoder_btn_standard_cont'/** 时长和内容 */),
        value: 'timeAndContent',
        tooltip: this.$t('pc_kng_uplaoder_lbl_standard_cont_tip'/** 完成标准学时和内容进度，即可获得学分（需课件支持内容记录） */)
      }],
      customPercent: undefined,
      percent: ''
    };
  },
  computed: {
    type: {
      get() {
        const { contentCompleteStandard, timeCompleteStandard } = this;
        if (contentCompleteStandard === 1 && !timeCompleteStandard) {
          return 'content';
        } else if (!contentCompleteStandard && timeCompleteStandard) {
          return 'time';
        } else if (contentCompleteStandard && timeCompleteStandard) {
          return 'timeAndContent';
        }
        return '';
      },
      set(val) {
        this.customPercent = undefined;
        if (val === 'content') {
          this.$emit('update:contentCompleteStandard', 1);
          this.$emit('update:timeCompleteStandard', 0);
        } else if (val === 'time') {
          this.$emit('update:contentCompleteStandard', 0);
          this.$emit('update:timeCompleteStandard', 100);
        } else if (val === 'timeAndContent') {
          this.$emit('update:contentCompleteStandard', 1);
          this.$emit('update:timeCompleteStandard', 100);
        }
      }
    }
  },
  watch: {
    timeCompleteStandard: {
      immediate: true,
      handler(val) {
        if ([100, 95, 90, 85, 80].includes(val)) {
          this.percent = val;
        } else {
          this.percent = val + '%';
          this.customPercent = val;
        }
      }
    },
    customPercent(val) {
      if (val === 0) return;
      if (val) {
        this.percent = val + '%';
      } else {
        this.percent = 100;
      }
    },
    percent(val) {
      this.$emit('update:timeCompleteStandard', parseInt(val, 10));
    }
  },
  methods: {
    change() {
      this.customPercent = undefined;
    }
  }
};
</script>
